import { Users } from 'components/users-and-access';

/** @ngInject */
export default function usersRouter($stateProvider) {
    const usersState = {
        url: '/users',
        views: {
            contentBody: {
                component: Users.Component.selector
            }
        }
    };

    $stateProvider
        .state('main.users-and-access.users', usersState);
}



// WEBPACK FOOTER //
// ./app/components/users-and-access/users/users.router.js